<mat-form-field [style.width]="'100%'">
  <mat-label>{{label | translate}}</mat-label>
  <mat-select [disabled]="mode != Mode.edition" [required]="required" value="{{object ? object.id : ''}}" (selectionChange)="onSelect($event.value)">
    <mat-option *ngIf="!required">{{'None' | translate}}</mat-option>
    <mat-option *ngFor="let object of objects" value="{{object.id}}">{{object.name}}</mat-option>
  </mat-select>
</mat-form-field>
